import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, retry, tap } from "rxjs/operators";
import { User } from "../pages/models/users";
import { StoreService } from "../pages/services/store.service";
import { UserService } from "../pages/services/users.service";
import { SharedService } from "./shared.service";
import { ToasterService } from "./toaster.service";

@Injectable({
  providedIn: "root",
})
export class UserResolverService implements Resolve<User[]> {
  constructor(
    private userService: UserService,
    private toaster: ToasterService,
    private storeService: StoreService,
    private sharedService: SharedService
  ) {}
  resolve(route: ActivatedRouteSnapshot): Observable<User[]> | User[] {
    if (this.sharedService.getUser()) {
      return [this.sharedService.getUser()];
    } else {
      return this.userService.getInfo().pipe(
        catchError((error) => {
          // console.log("some error");
          return of(null);
        }),
        tap((user: User[]) => {
          if (user[0]?.branch && window.innerWidth > 768)
            this.storeService
              .printBranchLoggedIn(user[0].branch)
              .subscribe((res) => {});
        }),
        retry(3)
      );
    }
  }
}
